/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getApiBlobsUploadUrlQueryParams = zod.object({
  "contentType": zod.string(),
  "contentHash": zod.string()
})

export const getApiBlobsUploadUrlResponse = zod.object({
  "uploadUrl": zod.string(),
  "fileUrl": zod.string(),
  "expiresAt": zod.string().datetime({}),
  "requiredHeaders": zod.record(zod.string(), zod.string())
})

export const getApiBlobsByHashHashParams = zod.object({
  "hash": zod.string()
})

export const getApiBlobsByHashHashResponse = zod.object({
  "id": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})

export const postApiBlobsBodyUrlMax = 2048;

export const postApiBlobsBodyHashMax = 128;

export const postApiBlobsBodyContentTypeMax = 255;

export const postApiBlobsBodyFileSizeMin = 0;
export const postApiBlobsBodyFileSizeMax = 9223372036854776000;



export const postApiBlobsBody = zod.object({
  "url": zod.string().min(1).max(postApiBlobsBodyUrlMax),
  "hash": zod.string().min(1).max(postApiBlobsBodyHashMax),
  "contentType": zod.string().max(postApiBlobsBodyContentTypeMax).nullish(),
  "fileSize": zod.number().min(postApiBlobsBodyFileSizeMin).max(postApiBlobsBodyFileSizeMax).nullish()
})

